import { queryPremiumRateForMEBandMEAPlus as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForMEB as calculateRiderPremium } from 'core/service/rider/premium-calculation'

export default {
  calculateRiderPremium,
  queryPremiumRate,
}
